<template>
  <!-- 商店商品 -->
  <v-sheet class="wd-px-5 wd-pt-4 wd-pb-2" elevation="0" rounded>
    <content-show-more v-model="isShowAll" :hide="isHideMoreButton">
      <div>
        <h2 class="wd-text-xl wd-font-medium wd-mb-3">{{ title }}</h2>
        <div class="wd-p-0 wd-flex wd-justify-between wd-item wd-flex-wrap">
          <div v-for="product in productsUiList" :key="product.product_id" class="wd-w-full sm:(wd-w-[49%] wd-max-w-326px wd-min-w-254px)">
            <ProductCard :product="product" :hide-rating="isFunBookV2" :hide-rrp="isFunBookV2" highlight-product-name />
          </div>
        </div>
      </div>
    </content-show-more>
  </v-sheet>
</template>

<script>
import { syncRefs } from '@vueuse/shared'
import ContentShowMore from '@/components/ContentShowMore.vue'
import ProductCard from '@/components/card/product.vue'
import { usePlatformStore } from '~/store-pinia/platform'
import { provideGtmSource } from '@/composition/useGtmSource'

export default defineComponent({
  components: {
    ContentShowMore,
    ProductCard,
  },
  props: {
    products: { type: Array, default: () => [] },
    threshold: { type: Number, default: 8 },
    source: { type: String, default: null },
  },
  setup(props) {
    provideGtmSource(props.source)
    const nuxtApp = useNuxtApp()
    const isShowAll = ref(false)
    const isHideMoreButton = computed(() => props.products.length <= props.threshold)
    // set isShowAll back to false if products more than threshold with branch changed ( none-rerender )
    syncRefs(isHideMoreButton, isShowAll)
    const productsUiList = computed(() => (isShowAll.value ? props.products : props.products.slice(0, props.threshold)))
    const { isFunBookV2 } = storeToRefs(usePlatformStore())
    const title = computed(() => (isFunBookV2.value ? nuxtApp.$i18n.t('all_package_list') : nuxtApp.$i18n.t('all_hot_package')))

    return {
      title,
      isShowAll,
      productsUiList,
      isFunBookV2,
      isHideMoreButton,
    }
  },
})
</script>
